export default __webpack_public_path__ + "static/media/checkbox-checked-tata-neu@2x.cddb9a94.png";